export default "__VITE_ASSET__Cq9858cZ__"